import React from "react";
import { createBrowserRouter, Navigate } from "react-router-dom";
import { ErrorPage, GenericPage, Login } from "../../pages/";
import { Layout } from "../../root";
import {
  optionsRoute,
  modelsRoute,
  userRoute,
  datasRoute,
  workflowRoute,
  clientRoute,
  toolsRoute,
  malimaxRoute,
} from "../routes";

const Dashboard = React.lazy(() => import("../../pages/lib/dashboard/page"));
const GenericExteriorPage = React.lazy(() => import("../../pages/lib/exterior-page/page"));
const GenericExteriorPageWfone = React.lazy(() => import("../../pages/lib/exterior-page/page-wf-one"));
const GenericExteriorPageWftwo = React.lazy(() => import("../../pages/lib/exterior-page/page-wf-two"));
const GenericExteriorPageWfthree = React.lazy(() => import("../../pages/lib/exterior-page/page-wf-three"));

export const router = createBrowserRouter([
  {
    path: "/login",
    element: <Login />,
  },
  {
    path:"/exterior",
    errorElement:<ErrorPage/>, 
    children:[
      {
        path: "container/*",
        element: <GenericExteriorPage />,
        errorElement:<ErrorPage/>,
      },
      {
        path: "workflow-one/*",
        element: <GenericExteriorPageWfone />,
        errorElement:<ErrorPage/>,
      },
      {
        path: "workflow-two/*",
        element: <GenericExteriorPageWftwo />,
        errorElement:<ErrorPage/>,
      },
      {
        path: "workflow-three/*",
        element: <GenericExteriorPageWfthree />,
        errorElement:<ErrorPage/>,
      },
      {
        path: "malimax-container/*",
        element: <GenericExteriorPage />,
        errorElement:<ErrorPage/>,
      },
      {
        path: "malimax-one/*",
        element: <GenericExteriorPageWfone />,
        errorElement:<ErrorPage/>,
      },
      {
        path: "malimax-two/*",
        element: <GenericExteriorPageWftwo />,
        errorElement:<ErrorPage/>,
      },
      {
        path: "malimax-three/*",
        element: <GenericExteriorPageWfthree />,
        errorElement:<ErrorPage/>,
      },
    ]
  },
  {
    path: "/",
    element: <Layout />,
    errorElement: <ErrorPage />,
    children: [
      {
        path: "dashboard",
        element: <Dashboard />,
        errorElement: <ErrorPage />,
      },
      {
        path: "datas",
        errorElement: <ErrorPage />,
        children: datasRoute,
      },
      {
        path: "models",
        errorElement: <ErrorPage />,
        children: modelsRoute,
      },
      {
        path: "options",
        errorElement: <ErrorPage />,
        children: optionsRoute,
      },
      {
        path: "tools",
        element: <GenericPage />,
        errorElement: <ErrorPage />,
        children: toolsRoute,
      },
      {
        path: "user",
        element: <GenericPage />,
        errorElement: <ErrorPage />,
        children: userRoute,
      },
      {
        path: "clients",
        element: <GenericPage />,
        errorElement: <ErrorPage />,
        children: clientRoute,
      },
      {
        path: "workflow",
        errorElement: <ErrorPage />,
        children: workflowRoute,
      },
      {
        path: "form-process",
        errorElement: <ErrorPage />,
        children: malimaxRoute,
      },
      {
        path: "",
        element: <Navigate replace to="dashboard" />,
      },
    ],
  },
  {
    path: "",
    element: <Login />,
  },
]);
